$(document).ready(function () {

    if (getShoptetDataLayer("pageType") == 'homepage') {

        const $carousel = $('#carousel');
        const $oldCarouselInner = $('.carousel-inner');
        const $oldSlides = $oldCarouselInner ? $oldCarouselInner.children() : [];

        // Remove all children of the carousel
        $carousel.empty();

        // Create Swiper container
        const $swiperContainer = $('<div>').addClass('swiper');
        $carousel.append($swiperContainer);

        // Create Swiper wrapper
        const $swiperWrapper = $('<div>').addClass('swiper-wrapper');
        $swiperContainer.append($swiperWrapper);

        // Create slides from old carousel
        $oldSlides.each(function () {
            const $oldSlide = $(this);
            const $newSlide = $('<div>').addClass('swiper-slide');

            // Get the original content
            const $originalLink = $oldSlide.find('a').first();
            const href = $originalLink.attr('href');
            const promoId = $originalLink.attr('data-ec-promo-id');
            const $img = $originalLink.find('img').first();
            const imgSrc = $img.attr('src');
            const title = $originalLink.find('.extended-banner-title').text();
            const ctaText = $originalLink.find('.extended-banner-link').text();

            // Parse JSON from text content - only video
            const textContent = $originalLink.find('.extended-banner-text').text();
            let videoUrl = '';
            let plainText = textContent;

            try {
                const jsonMatch = textContent.match(/^(\{[^}]+\})/);
                if (jsonMatch) {
                    plainText = textContent.replace(jsonMatch[1], '').trim();
                    const jsonStr = jsonMatch[1]
                        .replace(/(\w+)=/g, '$1:')
                        .replace(/(\w+):/g, '"$1":');
                    const parsed = JSON.parse(jsonStr);
                    videoUrl = parsed.video || '';
                }
            } catch (e) {
                console.error('Error parsing JSON:', e);
            }

            // Create new slide content
            const $link = $('<a>')
                .attr('href', href)
                .attr('data-ec-promo-id', promoId);

            // Add video if specified
            if (videoUrl) {
                const $videoContainer = $('<div>').addClass('video-container');
                const videoHtml = `<video autoplay="autoplay" loop="loop" muted="true" preload="auto" playsinline="true" poster="${imgSrc}"><source src="${videoUrl}" type="video/mp4">Váš prohlížeč nepodporuje přehrávání videa.</video>`;
                const $video = $(videoHtml);

                // Add fallback image
                const $fallbackImg = $img.clone();
                $videoContainer.append($video, $fallbackImg);
                $link.append($videoContainer);
            } else {
                $link.append($img.clone());
            }

            const $texts = $('<span>').addClass('extended-banner-texts');
            $texts.append(
                $('<span>').addClass('extended-banner-title').text(title),
                $('<span>').addClass('extended-banner-text').text(plainText),
                $('<span>').addClass('extended-banner-link').text(ctaText)
            );

            $link.append($texts);
            $newSlide.append($link);
            $swiperWrapper.append($newSlide);
        });

        // Add navigation arrows as direct children of #carousel (outside .swiper)
        const $prevButton = $('<div>').addClass('swiper-button-prev');
        const $nextButton = $('<div>').addClass('swiper-button-next');
        $carousel.append($prevButton, $nextButton);


        // Initialize Swiper
        const initSwiper = () => {
            if (typeof Swiper !== 'undefined') {
                // freeMode na kraji wheel pouští dál → gesto zpět v prohlížeči; vodorovný swipe nad sliderem zastavíme
                document.querySelector('#carousel .swiper').addEventListener('wheel', (e) => {
                    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) e.preventDefault();
                }, { passive: false });

                const swiperInstance = new Swiper('#carousel .swiper', {
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                    loop: false,
                    navigation: {
                        nextEl: '#carousel .swiper-button-next',
                        prevEl: '#carousel .swiper-button-prev',
                    },
                    freeMode: true,
                    mousewheel: {
                        forceToAxis: true,
                        releaseOnEdges: false,
                        sensitivity: 1,
                        thresholdDelta: 10,
                    },
                    breakpoints: {
                        0: {
                            slidesPerView: 'auto',
                            spaceBetween: 10,
                            slidesOffsetBefore: 10,
                            slidesOffsetAfter: 10,
                        },
                        768: {
                            slidesOffsetBefore: 0,
                            slidesOffsetAfter: 0,
                            slidesPerView: 2,
                        },
                        992: { 
                            slidesPerView: 3,
                        },
                        1200: {
                            slidesOffsetBefore: 0,
                            slidesOffsetAfter: 0,
                            slidesPerView: 4,
                            spaceBetween: 20,
                        }
                    },
                    on: {
                        init: function () {
                            console.log('Swiper byl inicializován!');
                        }
                    }
                });
            } else {
                setTimeout(initSwiper, 100);
            }
        };

        initSwiper();
    }
});